export const API_URL = process.env.REACT_APP_API;
export const GL_API = process.env.REACT_APP_GLAPI;
export const APPID = process.env.REACT_APP_APPID;